{
  "messages": {
    "rescheduledOnce": "已改期一次",
    "rescheduledTwice": "已改期两次",
    "rescheduledCountTimes": "已改期 {count} 次"
  }
}
